import { RequestOptions } from "../models/ApiRequest";
import { ApiDataResponse } from "../models/ApiResponse";
import qs from "qs";

type RequestParams = {
	method: "get" | "post" | "put" | "delete";
	path: string;
	query?: RequestOptions["query"];
	body?: any;
	token?: string;
	formData?: any;
	blobResponse?: boolean;
};

export default class FetchClient {
	/**
	 * Do request and return Blob when option
	 * blobResponse is .
	 */
	async doRequest<T>({
		method,
		path,
		query,
		body,
		token,
		formData,
	}: RequestParams & { blobResponse: true }): Promise<Blob>;

	/**
	 * Do request and response with JSON api response.
	 */
	async doRequest<T>({
		method,
		path,
		query,
		body,
		token,
		formData,
	}: RequestParams): Promise<ApiDataResponse<T>>;

	async doRequest<T>({
		method,
		path,
		query = undefined,
		body = undefined,
		token = undefined,
		formData = undefined,
		blobResponse = false,
	}: RequestParams): Promise<ApiDataResponse<T> | Blob> {
		let headers = new Headers();

		if (!formData) {
			headers = new Headers({
				Accept: "application/json",
				"Content-Type": "application/json",
			});
		}

		if (token) {
			headers.append("Authorization", `Bearer ${token}`);
		}

		const fetchOptions: RequestInit = {
			mode: "cors",
			credentials: token ? "include" : undefined,
			headers,
			method,
		};

		if (body) {
			if (formData) fetchOptions.body = body;
			else fetchOptions.body = JSON.stringify(body);
		}

		const queryStr = query ? "?" + qs.stringify(query) : "";

		const resp = await fetch(path + queryStr, fetchOptions);

		let jsonResp;

		try {
			if (blobResponse) {
				if (resp.status >= 400) {
					// API returns JSON for errors even when caller requested a blob.
					jsonResp = await resp.json();
				} else {
					return resp.blob();
				}
			} else {
				if (resp.status === 204 /* no content */) {
					jsonResp = {};
				} else {
					jsonResp = await resp.json();
				}
			}
		} catch (err) {
			// eslint-disable-next-line no-console
			console.log("Failed parsing response body", err);

			// Use this var for fix Expected an error object to be thrown for object lint issue
			const error = {
				status: 500,
				error: {
					code: "CLIENT_ERROR",
					detail: "Something went wrong when parsing response on client: " + err,
				},
			};

			throw error;
		}

		if (resp.status < 400) {
			return jsonResp;
		} else {
			throw jsonResp;
		}
	}
}
